const SKIP_KEY = 'mobile-number-required-skipped';

function getSessionStorage(): Storage | null {
  try {
    return window.sessionStorage ?? null;
  } catch {
    return null;
  }
}

export function setMobileNumberRequiredSkippedThisSession(): void {
  try {
    getSessionStorage()?.setItem(SKIP_KEY, '1');
  } catch {
    // sessionStorage may be unavailable (e.g. private browsing); skip silently
  }
}

export function mobileNumberRequiredSkippedThisSession(): boolean {
  try {
    return getSessionStorage()?.getItem(SKIP_KEY) === '1';
  } catch {
    return false;
  }
}
